import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { Calendar } from "primereact/calendar";

import { Card } from "primereact/card";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { deleteData, getSpecificDetails, postAllData, updateData } from "../../service/ProductService";
import {
  DELETE_EMPLOYEE,
  GET_CLIENT_DETAIL_BY_ID,
  SAVE_EMPLOYEE_DATA,
  UPDATE_EMPLOYEE_ACTIVE_STATUS,
  UPDATE_EMPLOYEE_DATA,
} from "../../config/ApiConstant";
import { DataTable } from "primereact/datatable";
import { EmployeeListColumns } from "../../appconfig/DatatableSetting";
import { Column } from "primereact/column";

import {
  defaultPageRowOptions,
  defaultRowOptions,
  EmployeeStatusDropdown,
  paginatorLinks,
  percentageOptions,
  provinces,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { addressTemplate, clientTemplate, dateTemplate, nameTemplate, wageBodyTemplate } from "../../appconfig/TemplateFieldSetting";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { Link } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { validateEmployeeForm, validateEmployeStatusDate } from "../../config/Validate";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { formatDate, formatMonthYear, formatMonthYearUtc, globalNameFilterTemplate } from "../../appconfig/AppHelper";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import moment from "moment";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import Loader from "../../components/Loader/Loader";
import { Password } from "primereact/password";
import ViewSinNumber from "../../components/ViewSinNumber/ViewSinNumber";
import { Badge } from "primereact/badge";

const ClientDetail = () => {
  const toast = useRef<any>(null);
  const { id } = useParams();
  const client_id = id
    ? (() => {
      try {
        return atob(id);
      } catch {
        return null;
      }
    })()
    : null;

  const [clientData, setClientData] = useState<any>(null);
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  const [addDeleteEmployeeDialog, setAddDeleteEmployeeDialog] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [clientHead, setClientHead] = useState<any>([]);
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<any>(null);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const [globleEmployeeData, setGlobalEmployeeData] = useState<any>({
    tax_deduction: "100",
  });

  // employee status
  const [employeeStatus, setEmployeeStatus] = useState<any>(null);

  // review status
  const [activeEmployeeId, setActiveEmployeeId] = useState<any>(null);

  // employee dropdown status
  const [selectedDropdownStatus, setSelectedDropdownStatus] = useState<any>(null);

  // employee status update date
  const [empStatusChangeDate, setEmpStatusChangeDate] = useState<any>(new Date());

  // active status dialog
  const [activeEmployeeDialog, setActiveEmployeeDialog] = useState<boolean>(false);

  // Client specific Employee List
  const [employeeList, setEmployeeList] = useState<any>([]);

  // roe issuer name
  const [roeIssuerName, setRoeIssuerName] = useState<any>(null);

  // payroll reference number
  const [payrollRefNo, setPayrollRefNo] = useState<any>(null);

  // who to contact for further information
  const [contactPerson, setContactPerson] = useState<any>("User");

  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";

  // filter
  const emptyFilters = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },

    name: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },

    email: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    sin_number: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    joining_date: {
      operator: FilterOperator.OR,
      constraints: [
        {
          value: null,
          matchMode: FilterMatchMode.DATE_IS,
        },
      ],
    },
    emp_status: {
      operator: FilterOperator.OR,
      constraints: [{ value: 'Active', matchMode: FilterMatchMode.EQUALS }],
    },
    phone: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  };
  const [filters, setFilters] = useState(emptyFilters);

  // Calculate the minimum date
  const today = new Date();
  const maxDate = new Date();
  maxDate.setFullYear(today.getFullYear() - 14);

  // useefect for get user list
  useEffect(() => {
    fetchClientDetail();
  }, [id]);

  // fetch client details
  const fetchClientDetail = async () => {
    try {
      const response = await getSpecificDetails(GET_CLIENT_DETAIL_BY_ID, client_id);

      // normalise date to convert into data object instead of string
      const normalise = response?.client?.employee?.map((item: any) => ({
        ...item,

        joining_date: item.joining_date ? new Date(item.joining_date.substring(0, 10) + "T00:00:00") : null,

        // searchable name for globle filter
        first_name_search: item.first_name ? item?.first_name : "",
        last_name_search: item.last_name ? item?.last_name : "",

        // searchable joining date on globle filter
        joining_date_search: item.joining_date ? moment(item.joining_date).format("DD MMM YYYY") : "",
      }));

      setClientData(response?.client);
      setEmployeeList(normalise);
      setPageLoad(true);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
    }
  };

  // delete confirmation modal
  const confirmDelete = (deleteID: any) => {
    setDeleteId(deleteID);
    setDeleteDialog(true);
  };

  // on status change
  // const onStatusChange = (rowData: any) => {
  //   setActiveEmployeeId(rowData.id);
  //   setSelectedDropdownStatus(rowData.emp_status);

  //   //Use employee’s status date if available
  //   if (rowData?.emp_status_date) {
  //     const parsedDate = moment(rowData.emp_status_date, "YYYY-MM-DD").toDate();
  //     setEmpStatusChangeDate(parsedDate);
  //   } else {
  //     setEmpStatusChangeDate(new Date());
  //   }

  //   setActiveEmployeeDialog(true);
  // };

  const onStatusChange = (rowData: any) => {
    setActiveEmployeeId(rowData.id);
    setSelectedDropdownStatus(rowData.emp_status);

    if (rowData?.employee_roe) {
      setRoeIssuerName(rowData?.employee_roe?.issuer_name);
      setPayrollRefNo(rowData?.employee_roe?.payroll_ref_no);
    }

    //Use employee’s status date if available
    if (rowData?.emp_status_date) {
      const parsedDate = moment(rowData.emp_status_date, "YYYY-MM-DD").toDate();
      setEmpStatusChangeDate(parsedDate);
    } else {
      setEmpStatusChangeDate(new Date());
    }

    setActiveEmployeeDialog(true);
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="action">
      <Button
        icon="pi pi-ellipsis-v"
        tooltip="Change Status"
        className="common-primary-button mr-2"
        tooltipOptions={{ position: "bottom" }}
        onClick={(e) => onStatusChange(rowData)}
      />
      <Button
        icon="pi pi-pencil"
        tooltip="Edit"
        className="common-edit-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => addEditDialog(rowData)}
      />
      <Button
        icon="pi pi-trash"
        tooltipOptions={{ position: "bottom" }}
        className="ml-2 p-button-danger common-delete-btn"
        tooltip="Delete"
        onClick={() => confirmDelete(rowData.id)}
      />
    </div>
  );
  const salaryTemplate = (rowData: any) => {
    return (
      <div className="actions">
        {rowData?.is_salary ? <Badge severity="success" value="Yes" style={{ width: "fit-content" }}></Badge> : <Badge severity="danger" value="No" style={{ width: "fit-content" }}></Badge>}
      </div>
    );
  };
  // clear all filter
  const clearAll = () => {
    setFilters({ ...emptyFilters });
    setGlobalFieldFilter(null);
    setGlobalFilter(null);
  };

  // global search filter on change
  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilter(value);
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <span className="block mr-2 p-input-icon-left">
      <i className="pi pi-search" />
      {/* <InputText type="search" value={globalFilter || ""} onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." /> */}
      <InputText type="search" value={globalFilter || ""} onChange={onGlobalFilterChange} placeholder="Search..." />
    </span>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <Button icon="pi pi-filter-slash" label="Clear" onClick={clearAll} className="mr-2 p-button-outlined common-p-outline-button" />

      <Button className="ml-1 common-primary-button" icon="pi pi-plus" label="Add Employee Data" onClick={() => addEditDialog()} />
    </>
  );

  //  employee detail template
  const employeeDetailTemplate = (rowData: any) => {
    return (
      <Link style={{ textDecoration: "underline", color: "blue" }} to={`/employee/${btoa(rowData.id)}`}>
        {rowData.unique_id}
      </Link>
    );
  };

  // sin Number template
  const sinNumberTemplate = (rowData: any) => {
    return (
      <div className="actions">
        <ViewSinNumber label="SIN Number" value={rowData?.sin_number} />
      </div>
    );
  };

  const hideDeleteDialog = () => {
    setDeleteDialog(false);
    setDeleteId(null);
  };

  // add & edit dialog
  const addEditDialog = async (rowData: any = null) => {
    if (rowData) {
      setGlobalEmployeeData({ tax_deduction: "100", ...rowData });
      setIsEdit(true);
    } else {
      setGlobalEmployeeData({ tax_deduction: "100" });
      setIsEdit(false);
    }

    setErrors({});
    setAddDeleteEmployeeDialog(true);
  };

  // onchange input value get
  const onInputChange = (e: any, name: string) => {
    let val;
    if (name === "ei_exempt" || name === "cpp_exempt" || name === "vacation_hold" || name === "no_vacation_payout" || name === "is_salary") {
      val = e.checked ? true : false;
    } else if ((name === "joining_date" && val) || (name === "date_of_birth" && val)) {
      val = moment(val).format("YYYY-MM-DD");
    } else {
      val = e?.target?.value ?? e?.value;
    }

    // format postal code: add space after 3 characters
    if (name === "postal_code" && val) {
      // remove all spaces first
      val = val.replace(/\s+/g, "").toUpperCase();
      // insert space after 3 characters if length > 3
      if (val.length > 3) {
        val = val.slice(0, 3) + " " + val.slice(3);
      }
    }

    setGlobalEmployeeData({ ...globleEmployeeData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  // add & update employee api call
  const submitEmployeeForm = async () => {
    const { isError, errors } = validateEmployeeForm(globleEmployeeData, isEdit);
    setErrors(errors);
    if (isError) return;

    setSubmitLoading(true);

    const payload = {
      // id: globleEmployeeData.id,
      first_name: globleEmployeeData.first_name,
      last_name: globleEmployeeData.last_name,
      email: globleEmployeeData.email,
      phone: globleEmployeeData.phone,
      occupation: globleEmployeeData.occupation,
      address: globleEmployeeData.address,
      joining_date: globleEmployeeData.joining_date ? moment(globleEmployeeData.joining_date).format("YYYY-MM-DD") : null,
      sin_number: globleEmployeeData.sin_number,
      tax_deduction: globleEmployeeData.tax_deduction,
      wage: globleEmployeeData.wage,
      is_salary: globleEmployeeData.is_salary ? 1 : 0,
      wage_night: globleEmployeeData?.wage_night,
      client_head: client_id,
      date_of_birth: globleEmployeeData.date_of_birth ? moment(globleEmployeeData.date_of_birth).format("YYYY-MM-DD") : null,
      ei_exempt: globleEmployeeData.ei_exempt ? 1 : 0,
      cpp_exempt: globleEmployeeData.cpp_exempt ? 1 : 0,
      vaccation_payout: globleEmployeeData.vaccation_payout,
      vacation_hold: globleEmployeeData?.vacation_hold ? 1 : 0,
      no_vacation_payout: globleEmployeeData?.no_vacation_payout ? 1 : 0,
      // pay_stat_holiday: globleEmployeeData?.pay_stat_holiday ? 1 : 0,
      province: globleEmployeeData?.province,
      postal_code: globleEmployeeData?.postal_code,
      city: globleEmployeeData?.city,
      type: "Employee",
    };

    try {
      const response = isEdit
        ? await updateData(UPDATE_EMPLOYEE_DATA, globleEmployeeData?.id, payload)
        : await postAllData(SAVE_EMPLOYEE_DATA, payload);

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hideAddEditEmployeeDialog();
        fetchClientDetail();
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // hide add & edit employee modal
  const hideAddEditEmployeeDialog = () => {
    setAddDeleteEmployeeDialog(false);
    setSubmitLoading(false);
  };

  // delete employee api call
  const deleteEmployee = async () => {
    try {
      setSubmitLoading(true);
      const response = await deleteData(DELETE_EMPLOYEE, deleteId);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: response.message,
        });
        hideDeleteDialog();
        fetchClientDetail();
        setSubmitLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setSubmitLoading(false);
    }
  };

  // active status employee Template
  const activeEmployeeStatusTemplate = (rowData: any) => {
    let statusClass: any =
      rowData?.emp_status === "Terminated"
        ? "danger"
        : rowData?.emp_status === "Active"
          ? "success"
          : rowData?.emp_status === "Paid leave of absence"
            ? "contrast"
            : rowData?.emp_status === "Unpaid leave of absence"
              ? "info"
              : rowData?.emp_status === "Not on payroll"
                ? "warning"
                : rowData?.emp_status === "Deceased"
                  ? "secondary"
                  : "";
    return (
      <div className="action flex flex-column align-items-center">
        <Badge severity={statusClass} value={rowData.emp_status} style={{ width: "fit-content" }}></Badge>
      </div>
    );
  };

  // active employee status template
  const employeeStatusFilterTemplate = (options: any) => {
    return (
      <Dropdown
        // filter
        value={employeeStatus}
        onChange={(e: any) => {
          setEmployeeStatus(e.value);
          options.filterCallback(e.value ? e.value : null, options.index);
        }}
        options={EmployeeStatusDropdown}
        optionLabel="name"
        placeholder="Status"
        className="order-drp"
      ></Dropdown>
    );
  };

  // status active employee api call
  const approveStatusUpdate = async () => {
    try {
      const isActive = selectedDropdownStatus === "Active";

      // Validate only when date field is visible
      const { isError, errors } = validateEmployeStatusDate(empStatusChangeDate, selectedDropdownStatus, roeIssuerName, payrollRefNo);
      setErrors(errors);
      if (isError) return;

      setSubmitLoading(true);

      const payload = {
        emp_status: selectedDropdownStatus,
        emp_status_date: !isActive ? moment(empStatusChangeDate).format("YYYY-MM-DD") : null,
        issuer_name: roeIssuerName,
        payroll_ref_no: payrollRefNo,
        contact_person: contactPerson,
      };

      //call api
      const response = await updateData(UPDATE_EMPLOYEE_ACTIVE_STATUS, activeEmployeeId, payload);

      if (response) {
        setPageLoad(true);
        setSubmitLoading(false);
        setEmpStatusChangeDate(new Date());
        fetchClientDetail();
        setRoeIssuerName(null);
        setPayrollRefNo(null);
        setContactPerson("User");
        setActiveEmployeeDialog(false);
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response?.message,
        });
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.message,
      });
      setPageLoad(true);
      setSubmitLoading(false);
      setActiveEmployeeDialog(false);
    }
  };

  // close employee status dialog
  const hideActiveDialog = () => {
    setActiveEmployeeDialog(false);
    setActiveEmployeeId(null);
    setSelectedDropdownStatus(null);
    setEmpStatusChangeDate(new Date());
    setRoeIssuerName(null);
    setPayrollRefNo(null);
    setContactPerson("User");
  };

  // date filter template
  const dateFilterTemplate = (options: any) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterApplyCallback(e.value)}
        dateFormat="dd/mm/yy"
        placeholder="Select Date"
        showIcon
      />
    );
  };

  return (
    <>
      <AppBreadcrumb currentMenu="Employee" pageName="List" pageTitle="Client Detail" goToPage={true} />

      <Card className="bg-white lg:p-2 crud-demo relative" style={{ marginBottom: "2rem" }}>
        {clientData ? (
          <div className="grid">
            {/* name and logo header */}
            <div className="flex gap-2 align-items-center mb-3 col-12">
              <div className="flex gap-2 align-items-center">
                {clientData?.company_logo ? (
                  <img
                    src={clientData?.company_logo}
                    alt="Company Logo"
                    style={{ width: "130px", height: "130px", borderRadius: "50%", objectFit: "contain", border: "1px solid #dee2e6" }}
                  />
                ) : (
                  <h2 className="mt-1 mb-1 text-xl font-semibold text-gray-900">-</h2>
                )}
              </div>
              <div className="">
                <label className="font-bold text-gray-700">Company Name :</label>
                <div className="flex gap-2 align-items-center">
                  <h2 className="mt-1 mb-1 text-xl font-semibold text-gray-900">{clientData?.company_name ?? ""}</h2>
                </div>
              </div>
            </div>

            {/* other details */}
            <div className="col-12 md:col-12">
              <div className="grid p-fluid">
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Email:</label>
                  <div>{clientData?.email || "-"}</div>
                </div>
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Phone:</label>
                  <div>{clientData?.phone || "-"}</div>
                </div>

                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Website Url:</label>
                  <div>
                    {clientData?.website_url ? (
                      <a
                        style={{ color: "blue", textDecoration: "underline" }}
                        href={clientData?.website_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {clientData?.website_url}
                      </a>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>

                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Pay Scheme:</label>
                  <div>{clientData?.pay_schema || "-"}</div>
                </div>

                {clientData?.custom_bi_weekly === true && clientData?.pay_schema === "Bi Weekly" && (
                  <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                    <label style={{ fontWeight: "bold" }}>Bi Weekly Cycle Start Date:</label>
                    <div>{clientData?.bi_weekly_start_date ? `${formatDate(clientData?.bi_weekly_start_date)}` : "-"}</div>
                  </div>
                )}

                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Pay Cheque Day:</label>

                  <div> {clientData?.pay_schema === "Bi Weekly" ? "Upcoming Friday" : clientData?.paycheck}</div>
                </div>
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Client Payment:</label>
                  <div>{`$${clientData?.client_charge}` || "-"}</div>
                </div>
                {userRole === "Admin" && (
                  <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                    <label style={{ fontWeight: "bold" }}>Client Payment Start Date:</label>
                    <div>{clientData?.client_subs_month_year ? `${formatMonthYearUtc(clientData?.client_subs_month_year)}` : "-"}</div>
                  </div>
                )}

                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Client Payroll Start Date:</label>
                  <div>{clientData?.client_payroll_starts_from ? `${formatMonthYearUtc(clientData?.client_payroll_starts_from)}` : "-"}</div>
                </div>
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Supervisor:</label>
                  <div>
                    {" "}
                    {clientData?.user?.first_name} {clientData?.user?.last_name}
                  </div>
                </div>
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Business No:</label>
                  <div>{clientData?.bussiness_number?.slice(0, 9) + " RP " + clientData?.bussiness_number?.slice(-4) || "-"}</div>
                </div>
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Postal Code:</label>
                  <div>{clientData?.postal_code || "-"}</div>
                </div>
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>GST Number:</label>
                  <div>{clientData?.gst_no || "-"}</div>
                </div>
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Address:</label>
                  <div>{clientData?.address || "-"}</div>
                </div>
              </div>
            </div>
            <hr />
          </div>
        ) : (
          ""
        )}
        <hr />
        <h5 className="mb-3">Employee Lists</h5>
        <Toast ref={toast} />
        <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />

        {pageLoad ? (
          <DataTable
            value={employeeList}
            showGridlines
            dataKey="id"
            stripedRows
            globalFilter={globalFilter}
            rows={defaultRowOptions}
            paginator={clientData.employee.length > 0}
            rowsPerPageOptions={defaultPageRowOptions}
            className="datatable-responsive p-datatble-sm"
            responsiveLayout={"scroll"}
            paginatorTemplate={paginatorLinks}
            currentPageReportTemplate={showingEntries + " Employees"}
            emptyMessage="No Employees Found"
            // filters={globalFieldFilter}
            // onFilter={(e) => setGlobalFieldFilter(e.filters)}
            filters={filters}
            onFilter={(e: any) => setFilters(e.filters)}
            globalFilterFields={[
              "unique_id",
              "wage",
              "emp_status",
              "first_name",
              "last_name",
              "email",
              "phone",
              "joining_date_search",
              "joining_date",
              "sin_number",
              "province",
              "city",
              "postal_code",
              "address",
              "gst_no",
            ]}
            removableSort
          >
            {EmployeeListColumns.map((col) => {
              if (col.field === "name") {
                return <Column key={col.field} field={col.field} header={col.header} body={nameTemplate} />;
              } else if (col.field === "action") {
                return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
              } else if (col.field === "wage") {
                return <Column key={col.field} field={col.field} header={col.header} body={wageBodyTemplate} />;
              } else if (col.field === "is_salary") {
                return <Column key={col.field} field={col.field} header={col.header} body={salaryTemplate} />;
              } else if (col.field === "address") {
                return <Column key={col.field} field={col.field} header={col.header} body={addressTemplate} />;
              } else if (col.field === "sin_number") {
                return <Column key={col.field} field={col.field} header={col.header} body={sinNumberTemplate} />;
              } else if (col.field === "emp_status") {
                return (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={activeEmployeeStatusTemplate}
                    filter
                    filterField="emp_status"
                    filterElement={employeeStatusFilterTemplate}
                  />
                );
              } else if (col.field === "client_head") {
                return (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    // body={userTemplate}
                    body={(rowData) => clientTemplate(rowData.client)}
                  />
                );
              } else if (col.field === "unique_id") {
                return <Column key={col.field} field={col.field} header={col.header} body={employeeDetailTemplate} />;
              } else if (col.field === "joining_date") {
                return (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={dateTemplate}
                    sortable
                    filterPlaceholder={col.header}
                    dataType="date"
                    filter
                    filterElement={dateFilterTemplate}
                  />
                );
              } else if (col.field === "province") {
                return <Column key={col.field} field={col.field} header={col.header} />;
              } else {
                return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={col.header} />;
              }
            })}
          </DataTable>
        ) : (
          <DataTable value={Skeletonitems}>
            {EmployeeListColumns.map((col) => (
              <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
            ))}
          </DataTable>
        )}
        {pageLoad === false && <Loader />}
      </Card>
      <Dialog
        visible={addDeleteEmployeeDialog}
        style={{ width: "800px" }}
        className="mx-3 lg:mx-0"
        draggable={false}
        header={isEdit ? "Edit Employee" : "Add Employee"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideAddEditEmployeeDialog} />
            <Button label="Submit" icon="pi pi-check" className="common-primary-button" onClick={submitEmployeeForm} loading={submitLoading} />
          </div>
        }
        onHide={hideAddEditEmployeeDialog}
      >
        <div className="grid p-fluid formgrid">
          {/* First Name */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">First Name *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.first_name || ""}
                name="first_name"
                autoComplete="off"
                placeholder="Enter First Name"
                onChange={(e) => onInputChange(e, "first_name")}
                className={errors["first_name"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["first_name"]}</small>
          </div>

          {/* Last Name */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">Last Name *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.last_name || ""}
                name="last_name"
                autoComplete="off"
                placeholder="Enter Last Name"
                onChange={(e) => onInputChange(e, "last_name")}
                className={errors["last_name"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["last_name"]}</small>
          </div>
          {/* Email */}
          <div className="field col-12 md:col-6">
            <label htmlFor="email">Email *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.email || ""}
                name="email"
                autoComplete="off"
                placeholder="Enter Email"
                onChange={(e) => onInputChange(e, "email")}
                className={errors["email"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["email"]}</small>
          </div>
          {/* Phone */}
          <div className="field col-12 md:col-6">
            <label htmlFor="phone">Phone *</label>
            <div className="flex-1 input-effect-div p-inputgroup">
              <span className="font-bold p-inputgroup-addon">+1</span>
              <InputText
                value={globleEmployeeData.phone || ""}
                name="phone"
                autoComplete="off"
                placeholder="Enter Phone Number"
                onChange={(e) => onInputChange(e, "phone")}
                className={errors["phone"] && "p-invalid"}
                keyfilter="pint"
                maxLength={10}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["phone"]}</small>
          </div>

          {/* Occupation */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">Occupation </label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.occupation || ""}
                name="occupation"
                autoComplete="off"
                placeholder="Enter Occupation"
                onChange={(e) => onInputChange(e, "occupation")}
                className={errors["occupation"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["occupation"]}</small>
          </div>

          {/* Joining Date */}
          <div className="field col-12 md:col-6">
            <label htmlFor="date">Joining Date *</label>
            <div className="input-effect-div">
              <Calendar
                value={globleEmployeeData.joining_date ? moment(globleEmployeeData.joining_date, "YYYY-MM-DD").toDate() : null}
                dateFormat="dd/mm/yy"
                placeholder="Enter Joining Date"
                onChange={(e) => onInputChange(e, "joining_date")}
                showIcon
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["joining_date"]}</small>
          </div>
          <div className="flex flex-wrap gap-3 justify-content-between field align-items-center col-12">
            <div className="mb-0 field-checkbox">
              <Checkbox
                inputId="checkOption4"
                name="is_salary"
                checked={globleEmployeeData.is_salary === true}
                onChange={(e) => onInputChange(e, "is_salary")}
              />
              <label htmlFor="checkOption2">Is Salary</label>
            </div>
          </div>

          {/* Wages 1 */}
          <div className="field col-12 md:col-6">
            <label htmlFor="wage">{globleEmployeeData.is_salary === true ? "Salary Amount *" : "Wage *"}</label>
            <form autoComplete="off">
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={globleEmployeeData.wage}
                  name="wage"
                  onChange={(e) => onInputChange(e, "wage")}
                  placeholder={globleEmployeeData.is_salary === true ? "Enter Salary Amount" : "Enter Wage"}
                  className={errors["wage"] && "p-invalid"}
                  // minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                  useGrouping={false}
                />
                {/* <span className="focus-bg"></span> */}
              </div>
            </form>

            <small className="p-invalid-txt">{errors["wage"]}</small>
          </div>

          {/* Wages 2 */}
          {(globleEmployeeData.is_salary === false || globleEmployeeData.is_salary === undefined) && (
            <div className="field col-12 md:col-6">
              <label htmlFor="wage_night">Wage 2 </label>
              <form autoComplete="off">
                <div className="flex-1 input-effect-div p-inputgroup">
                  <span className="font-bold p-inputgroup-addon">$</span>
                  <InputNumber
                    value={globleEmployeeData.wage_night}
                    name="wage_night"
                    onChange={(e) => onInputChange(e, "wage_night")}
                    placeholder="Enter Wage 2"
                    className={errors["wage_night"] && "p-invalid"}
                    // minFractionDigits={2}
                    maxFractionDigits={2}
                    mode="decimal"
                    useGrouping={false}
                  />
                  {/* <span className="focus-bg"></span> */}
                </div>
              </form>

              <small className="p-invalid-txt">{errors["wage_night"]}</small>
            </div>
          )}
          {/* Date of Birth */}
          <div className="field col-12 md:col-6">
            <label htmlFor="date">Date of Birth *</label>
            <div className="input-effect-div">
              <Calendar
                value={globleEmployeeData.date_of_birth ? moment(globleEmployeeData.date_of_birth, "YYYY-MM-DD").toDate() : null}
                dateFormat="dd/mm/yy"
                placeholder="Enter Date Of Birth"
                maxDate={maxDate}
                onChange={(e) => onInputChange(e, "date_of_birth")}
                showIcon
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["date_of_birth"]}</small>
          </div>

          {/* SIN number */}
          <div className="field col-12 md:col-6">
            <label htmlFor="number">SIN Number *</label>
            <div className="input-effect-div">
              <Password
                value={globleEmployeeData.sin_number || ""}
                name="sin_number"
                placeholder="Enter Sin Number"
                onChange={(e) => onInputChange(e, "sin_number")}
                toggleMask
                feedback={false}
                autoComplete="off"
                className={errors["sin_number"] && "p-invalid"}
                keyfilter="pint"
                maxLength={9}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["sin_number"]}</small>
          </div>

          {/* CheckBox */}

          <div className="flex flex-wrap gap-2 justify-content-between field align-items-center col-12 md:col-6">
            {/* CheckBox */}
            <div className="mb-0 field-checkbox">
              <Checkbox
                inputId="checkOption3"
                name="vacation_hold"
                checked={globleEmployeeData.vacation_hold === true}
                onChange={(e) => onInputChange(e, "vacation_hold")}
              />
              <label htmlFor="checkOption3">Vacation Payout On Hold</label>
            </div>

            {/* CheckBox */}
            <div className="mb-0 field-checkbox">
              <Checkbox
                inputId="checkOption4"
                name="no_vacation_payout"
                checked={globleEmployeeData.no_vacation_payout === true}
                onChange={(e) => onInputChange(e, "no_vacation_payout")}
              />
              <label htmlFor="checkOption2">No Vacation Payout</label>
            </div>
          </div>

          <div className="flex flex-wrap gap-3 justify-content-between field align-items-center col-12 md:col-6">
            {/* CheckBox */}
            <div className="mb-0 field-checkbox">
              <Checkbox
                inputId="checkOption1"
                name="ei_exempt"
                checked={globleEmployeeData.ei_exempt === true}
                onChange={(e) => onInputChange(e, "ei_exempt")}
              />
              <label htmlFor="checkOption1">EI Exempt</label>
            </div>

            {/* CheckBox */}
            <div className="mb-0 field-checkbox">
              <Checkbox
                inputId="checkOption2"
                name="cpp_exempt"
                checked={globleEmployeeData.cpp_exempt === true}
                onChange={(e) => onInputChange(e, "cpp_exempt")}
              />
              <label htmlFor="checkOption2">CPP Exempt</label>
            </div>

            {/* stat holiday */}
            <div className="">
              {/* <div className="mb-0 field-checkbox">
                <Checkbox
                  inputId="statholiday"
                  name="pay_stat_holiday"
                  checked={globleEmployeeData.pay_stat_holiday === true}
                  onChange={(e) => onInputChange(e, "pay_stat_holiday")}
                />
                <label htmlFor="statholiday">Pay Stat Holiday</label>
              </div> */}
            </div>
          </div>

          {/* vacation payout*/}
          <div className="field col-12 md:col-6">
            <label htmlFor="vaccation_payout">Vacation Payout*</label>
            <form autoComplete="off">
              <div className="flex-1 input-effect-div p-inputgroup">
                <InputNumber
                  value={globleEmployeeData.vaccation_payout}
                  name="vaccation_payout"
                  onChange={(e) => onInputChange(e, "vaccation_payout")}
                  placeholder="Enter Vacation Payout"
                  className={errors["vaccation_payout"] && "p-invalid"}
                  // minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                  useGrouping={false}
                />
                <span className="font-bold p-inputgroup-addon">%</span>
                {/* <span className="focus-bg"></span> */}
              </div>
            </form>

            <small className="p-invalid-txt">{errors["vaccation_payout"]}</small>
          </div>

          {/* Tax deduction */}
          <div className="field col-12 md:col-6">
            <label htmlFor="wage">Tax Deduction*</label>
            <form autoComplete="off">
              <div className="flex-1 input-effect-div p-inputgroup">
                <Dropdown
                  value={globleEmployeeData.tax_deduction || ""}
                  onChange={(e) => onInputChange(e, "tax_deduction")}
                  options={percentageOptions}
                  optionLabel="name"
                  optionValue="value"
                  id={"tax_deduction"}
                  placeholder="Select Tax Percentage"
                  className="order-drp"
                />
                <span className="font-bold p-inputgroup-addon">%</span>
                {/* <span className="focus-bg"></span> */}
              </div>
            </form>

            <small className="p-invalid-txt">{errors["tax_deduction"]}</small>
          </div>

          {/* provinces */}
          <div className="field md:col-6 col-12">
            <label htmlFor="province">Select Province *</label>
            <Dropdown
              value={globleEmployeeData.province || ""}
              onChange={(e) => onInputChange(e, "province")}
              options={provinces}
              placeholder="Select Province"
              className={errors["province"] ? "p-invalid" : ""}
            />
            <small className="p-invalid-txt">{errors["province"]}</small>
          </div>

          {/* city */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">City *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.city || ""}
                name="city"
                placeholder="Enter City"
                autoComplete="off"
                onChange={(e) => onInputChange(e, "city")}
                className={errors["city"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["city"]}</small>
          </div>

          {/* Postal Code */}
          <div className="field col-12 md:col-6">
            <label htmlFor="postal_code">Postal Code *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.postal_code || ""}
                name="postal_code"
                placeholder="Enter Postal Code"
                autoComplete="off"
                onChange={(e) => onInputChange(e, "postal_code")}
                className={errors["postal_code"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["postal_code"]}</small>
          </div>

          {/* street Address */}
          <div className="field col-12 md:col-6">
            <label htmlFor="address">Street Address *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.address || ""}
                name="address"
                placeholder="Enter Street Address"
                maxLength={30}
                autoComplete="off"
                onChange={(e) => onInputChange(e, "address")}
                className={errors["address"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["address"]}</small>
          </div>
        </div>
      </Dialog>
      {/* Delete Dialog */}
      <Dialog
        visible={deleteDialog}
        header="Delete Employee"
        draggable={false}
        className="mx-3 lg:mx-0"
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideDeleteDialog} />
            <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteEmployee} loading={submitLoading} />
          </div>
        }
        onHide={hideDeleteDialog}
      >
        <div className="flex align-items-center justify-content-start">
          <i className="mr-3 pi pi-exclamation-triangle delete-triangle" style={{ fontSize: "2rem" }} />
          <span className="delete-dialog-note">Are you sure you want to delete this Employee?</span>
        </div>
      </Dialog>

      {/* employee active dialog */}
      <Dialog
        visible={activeEmployeeDialog}
        style={{ width: "450px" }}
        header="Status Update"
        className="mx-3 lg:mx-0"
        draggable={false}
        modal
        footer={
          <>
            <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={hideActiveDialog} />
            <Button label="Confirm" icon="pi pi-check" className="common-primary-button" onClick={approveStatusUpdate} loading={submitLoading} />
          </>
        }
        onHide={hideActiveDialog}
      >
        <div className="">
          {
            <div className="grid p-fluid formgrid">
              <div className="field col-12 ">
                <label htmlFor="status">
                  Select Status <span className="required">*</span>
                </label>
                <Dropdown
                  value={selectedDropdownStatus}
                  onChange={(e) => setSelectedDropdownStatus(e.value)}
                  options={EmployeeStatusDropdown.filter((status) => status.value !== "Active")}
                  optionLabel="name"
                  optionValue="value"
                  placeholder="Select Status"
                />
              </div>

              {selectedDropdownStatus !== "Active" && (
                <div className="field col-12">
                  <label htmlFor="date">Select Date *</label>
                  <div className="input-effect-div">
                    <Calendar
                      value={empStatusChangeDate}
                      dateFormat="dd/mm/yy"
                      placeholder="Select Date"
                      onChange={(e) => setEmpStatusChangeDate(e.value)}
                      showIcon
                    />
                    <span className="focus-bg"></span>
                  </div>
                  <small className="p-invalid-txt">{errors["emp_status_date"]}</small>
                </div>
              )}

              {selectedDropdownStatus && selectedDropdownStatus !== "Active" && (
                <div className="field col-12 ">
                  <label htmlFor="name">ROE Issuer Name *</label>
                  <div className="input-effect-div">
                    <InputText
                      value={roeIssuerName || ""}
                      name="issuer_name"
                      autoComplete="off"
                      placeholder="Enter ROE Issuer name"
                      onChange={(e) => setRoeIssuerName(e?.target?.value)}
                      className={errors["issuer_name"] && "p-invalid"}
                    />
                    <span className="focus-bg"></span>
                  </div>
                  <small className="p-invalid-txt">{errors["issuer_name"]}</small>
                </div>
              )}

              {selectedDropdownStatus && selectedDropdownStatus !== "Active" && (
                <div className="field col-12 ">
                  <label htmlFor="contact_person">Who to contact for further information?</label>
                  <div className="flex gap-4 mt-2">
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="contact_person_user"
                        name="contact_person"
                        value="User"
                        onChange={(e) => setContactPerson(e.value)}
                        checked={contactPerson === "User"}
                      />
                      <label htmlFor="contact_person_user" className="ml-2">
                        User
                      </label>
                    </div>
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="contact_person_client"
                        name="contact_person"
                        value="Client"
                        onChange={(e) => setContactPerson(e.value)}
                        checked={contactPerson === "Client"}
                      />
                      <label htmlFor="contact_person_client" className="ml-2">
                        Client
                      </label>
                    </div>
                  </div>
                </div>
              )}

              {selectedDropdownStatus && selectedDropdownStatus !== "Active" && (
                <div className="field col-12 ">
                  <label htmlFor="payroll_ref_no">Payroll Reference Number *</label>
                  <div className="input-effect-div">
                    <InputText
                      value={payrollRefNo || ""}
                      name="payroll_ref_no"
                      autoComplete="off"
                      placeholder="Enter Payroll Reference Number"
                      onChange={(e) => setPayrollRefNo(e?.target?.value)}
                      className={errors["payroll_ref_no"] && "p-invalid"}
                    />
                    <span className="focus-bg"></span>
                  </div>
                  <small className="p-invalid-txt">{errors["payroll_ref_no"]}</small>
                </div>
              )}
            </div>
          }
        </div>
      </Dialog>
    </>
  );
};

export default ClientDetail;
